import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// images
import desktopImageWebp from './images/children-sitting-in-the-grass.webp';
import mobileImageWebp from './images/children-sitting-in-the-grass-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='philanthropy-financial-planning'
      moduleName='financial-planning-module'
      moduleVariation='A'
      disableBottomPadding
      reverseContent={false}
      // content
      subHeadingText='Our Community Impact'
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Every day we&#39;re improving lives of children and families and making a lasting impact in the communities we serve by providing employment opportunities, local business investments and guidance to our policyowners.
          </Typography>
          <Typography nextElement='link'>
            And we make an impact by giving back to the people and communities we serve. Together with our partners we&#39;re improving education; revitalizing neighborhoods; enhancing our hometown by ensuring it is an inviting and exciting place to live, work and play; and accelerating the search for cures for childhood cancer.
          </Typography>
          <Link
            id='2022-annual-meeting-nm-foundation-link'
            linkUrl='https://www.northwesternmutual-foundation.com/'
            variant='buttonLinkTertiary'
            ariaLabel='Visit the Northwestern Mutual Foundation website and learn more about what we do.'
            endAdornment={CaratRight}
            endAdornmentStylesReset
            isOutgoingLink>
            Visit our site and learn more about what we do
          </Link>
        </>
      )}
      // image props
      imageAltText='Children sitting in the grass.'
      imageSrcDefault={desktopImageWebp}
      imageSrcMobile={mobileImageWebp}
    />
  );
};
